module.exports = __webpack_public_path__ + "img/operator.180271f7.png";